import { useState } from "react";
import axios from "axios";
import { toast } from "react-toastify";
import Modal from "react-modal";
import moment from "moment";
import { ButtonSkeleton } from "./CalendarComponents/SkeletonLoader.jsx";
import crossImage from "../../images/singleinvoice/cross-red.svg";
import Delete from "../../images/icons/delete.svg";

const DeleteGoogleEventModal = ({
    deleteGoogleEventModalOpen,
    setDeleteGoogleEventModalOpen,
    setSelectedEvents,
    selectedGoogleEventForDelete,
    setSelectedGoogleEventForDelete,
    setExpandedEventIndex,
    refetchEvents,
    refetchSelectedGoogleEvents,
    setModalIsOpen,
    token,
}) => {
    const [deleteScope, setDeleteScope] = useState('thisEvent');
    const [isDeleting, setIsDeleting] = useState(false);
    const handleDeleteGoogleEvent = async (eventId, googleUserId, deleteScope = 'thisEvent', recurringEventId = null, instanceDate = null) => {
        try {
            setIsDeleting(true);

            const config = {
                headers: {
                    Authorization: `Bearer ${token}`,
                },
                params: {
                    deleteScope,
                    recurringEventId: recurringEventId || null,
                    instanceDate: instanceDate ? moment(instanceDate).format('YYYYMMDDTHHmmss[Z]') : null,
                    googleUserId,
                },
            };

            await axios.delete(`/api/google-calendar/events/delete/${eventId}`, config);

            global.config.activityLog(
                window.location.href,
                "Event Deletion",
                `Google Calendar event "${eventId}" deleted successfully (${deleteScope === 'thisEvent' ? 'this event only' : 'this and following events'})`
            );
            toast.success(`Google Calendar event deleted successfully (${deleteScope === 'thisEvent' ? 'this event only' : 'this and following events'})`, {
                position: "bottom-right",
                autoClose: 2000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
            });

            refetchSelectedGoogleEvents();
            refetchEvents();
            // handleCloseCreateModal();
            // handleCloseCreateEventModal();
            setModalIsOpen(false);
            setExpandedEventIndex(null);
            setSelectedEvents([]);
            handleCancelDeleteGoogleEvent();
            document.body.classList.remove("ReactModal__Body--open");
        } catch (error) {
            console.error('Error deleting Google Calendar event:', error);
            global.config.slackMessage(error.toString());

            toast.error(error.response?.data?.message || 'Failed to delete Google Calendar event', {
                position: "bottom-right",
                autoClose: 2000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
            });
        } finally {
            setIsDeleting(false);
        }
    };

    const handleCancelDeleteGoogleEvent = () => {
        setDeleteGoogleEventModalOpen(false);
        setSelectedGoogleEventForDelete(null);
        setDeleteScope('thisEvent');
        document.body.classList.remove("ReactModal__Body--open");
    };

    const isRecurring =
        selectedGoogleEventForDelete?.extendedProps?.recurrence?.length > 0 ||
        selectedGoogleEventForDelete?.extendedProps?.recurringEventId;

    return (
        <Modal
            className="center-modal"
            isOpen={deleteGoogleEventModalOpen}
            onRequestClose={!isDeleting ? handleCancelDeleteGoogleEvent : undefined}
            contentLabel="Confirm Delete Event"
            style={{
                content: {
                    width: "300px",
                    height: "200px",
                    position: "fixed",
                    top: "50%",
                    left: "50%",
                    borderRadius: "12px",
                    background: "#fff",
                    boxShadow: "0 5px 15px rgba(0,0,0,0.2)",
                    border: "none",
                },
                overlay: {
                    backgroundColor: "rgba(0,0,0,0.5)",
                },
            }}
        >
            <div className="delete-modal-content">
                <div className="modal-close-invite outter-modal-main">
                    <a onClick={handleCancelDeleteGoogleEvent} disabled={isDeleting}>
                        <img src={crossImage} alt="Close Icon" />
                    </a>
                </div>
                <h2>{isRecurring ? `Delete recurring event for ${selectedGoogleEventForDelete?.calendarEmail}?` : `Delete event for ${selectedGoogleEventForDelete?.calendarEmail}?`}</h2>
                {/* <p>Are you sure you want to delete this event?</p> */}
                {isRecurring ? (
                    <>
                        {/* <p>Delete this recurring event?</p> */}
                        <div className="delete-options-recuring">
                            <label className="radio-options">
                                <input
                                    type="radio"
                                    value="thisEvent"
                                    checked={deleteScope === 'thisEvent'}
                                    onChange={() => setDeleteScope('thisEvent')}
                                    disabled={isDeleting}
                                />
                                <span>This event only</span>
                            </label>
                            <label className="radio-options">
                                <input
                                    type="radio"
                                    value="thisAndFollowing"
                                    checked={deleteScope === 'thisAndFollowing'}
                                    onChange={() => setDeleteScope('thisAndFollowing')}
                                    disabled={isDeleting}
                                />
                                <span>This and following events</span>
                            </label>
                        </div>
                    </>
                ) : (
                    <p>Are you sure you want to delete this event?</p>
                )}
                <div className="delete-modal-buttons">
                    <button
                        onClick={() =>
                            handleDeleteGoogleEvent(
                                selectedGoogleEventForDelete.extendedProps.googleEventId,
                                selectedGoogleEventForDelete.extendedProps.googleUserId,
                                deleteScope,
                                selectedGoogleEventForDelete.extendedProps.recurringEventId,
                                selectedGoogleEventForDelete.start
                            )
                        }
                        disabled={isDeleting || (isRecurring && !deleteScope)}
                        className="modal-btn modal-btn-calendar delete"
                    >
                        {isDeleting ? (
                            <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '8px' }}>
                                <ButtonSkeleton width="70px" height="18px" />
                            </div>
                        ) : (
                            <>
                                Delete
                                <img src={Delete} alt="Delete" />
                            </>
                        )}
                    </button>
                    <button
                        onClick={handleCancelDeleteGoogleEvent}
                        disabled={isDeleting}
                        className="modal-btn modal-btn-calendar cancel"
                    >
                        {isDeleting ? (
                            <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '8px' }}>
                                <ButtonSkeleton width="60px" height="18px" />
                            </div>
                        ) : (
                            "Cancel"
                        )}
                    </button>
                </div>

            </div>
        </Modal >
    );
};

export default DeleteGoogleEventModal;
